import { useEffect, useState } from 'react';

import { InputText } from '~shared/ui';

type UsersFilterProps = {
	search: string;
	onChange: (val: string) => void;
};

export function UsersFilter({ search, onChange }: UsersFilterProps) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const [idle, setIdle] = useState<any>(null);
	const [value, setValue] = useState<string>('');

	useEffect(() => {
		setValue(search);
	}, [search]);

	const handleSearch = (val: string) => {
		onChange(val);
	};

	const handleChangeSearch = (val: string) => {
		setValue(val);
		if (idle) clearTimeout(idle);
		setIdle(setTimeout(() => handleSearch(val), 1000));
	};

	return (
		<div className="users-filter">
			<InputText placeholder="Поиск" value={value} onChange={handleChangeSearch} />
		</div>
	);
}
